import { PublicClientApplication } from "@azure/msal-browser";
import { FRONTEND_URL } from "../../config";

export const msalConfig = {
    auth: {
        clientId: '416c6f24-50f3-4025-8a1b-b6442eb5d8fd',
        authority: 'https://login.microsoftonline.com/711f2702-c004-4887-af6e-961f941df9ec',
        redirectUri: `${FRONTEND_URL}/admin`
    },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  }
}

export const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["User.Read", "CustomSecAttributeAssignment.Read.All", "CustomSecAttributeDefinition.Read.All", "User.Read.All"]
};